const fields = [
  {
    key: 'day',
    label: 'global.field.date',
    header: 'date',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 20,
  },
  {
    key: 'totalDistance',
    label: 'report.fields.totalDistance',
    header: 'total_distance',
    filter: false,
    width: 10,
  },
  {
    key: 'totalHourTrip',
    label: 'report.fields.totalTimeTrip',
    header: 'total_hour_trip',
    filter: false,
    width: 10,
  },
  {
    key: 'totalHourTripStop',
    label: 'report.fields.totalTimeTripStop',
    header: 'total_hour_trip_stop',
    filter: false,
    width: 10,
  },
]
export default fields
